import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { UpsertSiteContentRequest } from '@pms/shared';
import {
  fetchSiteContent,
  upsertSiteContent,
} from '@/services/api/siteContent.api';

export const siteContentKeys = {
  all: ['site-content'] as const,
};

/** Stored homepage stat rows (a subset of the fixed key set). */
export function useSiteContent() {
  return useQuery({
    queryKey: siteContentKeys.all,
    queryFn: fetchSiteContent,
    staleTime: 15_000,
  });
}

/** Upsert one stat; refetches the list on success (refetch over optimistic). */
export function useUpsertSiteContent() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: UpsertSiteContentRequest) => upsertSiteContent(body),
    onSuccess: () =>
      void queryClient.invalidateQueries({ queryKey: siteContentKeys.all }),
  });
}
